import { PurposeType } from "./purpose.types";
import { TransactionPurpose } from "@prisma/client";

const GroupedPurpose: Record<PurposeType, TransactionPurpose[]> = {
  INCOMING: [
    "DEPOSIT",
    "INTEREST",
    "SALARY",
    "DIVIDEND",
    "INVESTMENT",
    "CASHBACK",
    "REWARD",
    "BONUS",
    "COMMISSION",
    "REFUND",
    "PENSION",
    "CHARGEBACK",
    "REVERSAL",
  ],
  NEUTRAL: [
    "TRANSFER_TO_OWN_ACCOUNT",
    "SUBSCRIPTION",
    "FOREIGN_EXCHANGE",
    "ADJUSTMENT",
    "UNKNOWN",
  ],
  OUTGOING: [
    "WITHDRAWAL",
    "FEE",
    "LOAN_REPAYMENT",
    "TAX",
    "RENT",
    "PENALTY",
    "PURCHASE",
    "PAYMENT",
    "TRANSFER_TO_OTHER_ACCOUNT",
    "STANDING_ORDER",
    "INSURANCE_PREMIUM",
    "UTILITY_BILL",
    "DONATION",
    "DIRECT_DEBIT",
  ],
};

export { GroupedPurpose };
